import { ICognitoSettings, IEnvironmentConfig, IEnvironmentSettings } from './environmentConfig';
import { defaultFeatureConfig, IFeatureSettings } from './featuresConfig';


export interface ILinkSettings {
  aboutUs: string;
  termsOfUse: string;
  privacyPolicy: string;
  contactUs: string;
  contactUsForRegistration: string;
  faqs: string;
  learnMore: string;
  custodialNominees: string;
  fees: string;
  interest: string;
  funds: string;
  investmentFunds: string;
  supportEmail: string;
  supportPhone: string;
  productDisclosure: string;
  pendingOrdersLearnMore: string;
  proofOfAddress: string;
  verified: string;
  regularInvestmentPlan: string;
  depositLink: string;
  summaryWidgetInfoLink: string;
}
export interface IAppConfig {
  environmentConfig: IEnvironmentConfig;
  env: IEnvironmentSettings;
  links: ILinkSettings;
  cognito: ICognitoSettings;
  features: IFeatureSettings;
}

export const defaultconfig:IAppConfig = {
  environmentConfig: undefined,
  env: undefined,
  links: undefined,
  cognito: undefined,
  features: defaultFeatureConfig
}